import React from 'react'
import { useParams, Link } from 'react-router-dom'
import { useLocale } from '../contexts/LocaleContext'
import { blogPosts } from '../data/blogPosts'
import SEO from './SEO.jsx'

function BlogPost() {
  const { id } = useParams()
  const { t, locale } = useLocale()
  const blogPath = locale === 'fr' ? '/fr/blog' : '/blog'
  
  const post = blogPosts.find(p => p.id === parseInt(id))
  
  if (!post) {
    return (
      <>
        <SEO
          title={t.blog.notFoundTitle}
          description={t.blog.notFoundDescription}
          canonical={`https://www.gymjourney.fit${blogPath}`}
          noIndex
        />
        <div className="container section">
          <div className="blog-not-found">
            <h1>Article not found</h1>
            <p>The article you're looking for doesn't exist.</p>
            <Link to={blogPath} className="btn primary">
              {t.blog.backToBlog}
            </Link>
          </div>
        </div>
      </>
    )
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString)
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })
  }

  const getCategoryName = (categoryId) => {
    const category = t.blog[categoryId] || categoryId
    return category
  }

  const enUrl = `https://www.gymjourney.fit/blog/${post.id}`
  const frUrl = `https://www.gymjourney.fit/fr/blog/${post.id}`
  const canonical = locale === 'fr' ? frUrl : enUrl

  return (
    <>
      <SEO
          title={post.title}
          description={post.excerpt}
          canonical={canonical}
          image={post.image.startsWith('http') ? post.image : `https://www.gymjourney.fit${post.image}`}
          type="article"
          alternates={{ en: enUrl, fr: frUrl }}
          datePublished={post.date}
          dateModified={post.date}
        />
      <article className="blog-post">
        <div className="container">
          <div className="blog-post-header">
            
            <div className="blog-post-meta">
              <span className="blog-post-category">
                {getCategoryName(post.category)}
              </span>
              <span className="blog-post-date">
                {t.blog.publishedOn} {formatDate(post.date)}
              </span>
              <span className="blog-post-read-time">
                {post.readTime}
              </span>
            </div>
            
            <h1 className="blog-post-title">{post.title}</h1>
            <p className="blog-post-excerpt">{post.excerpt}</p>
            
            <div className="blog-post-author">
              <div className="author-info">
                <span className="author-name">{post.author}</span>
                <span className="author-title">{post.authorTitle}</span>
              </div>
            </div>
          </div>
          
          <div className="blog-post-image">
            <img
              height={400}
              width={400}
              style={{width: '400px'}}
              src={post.image} 
              alt={post.title}
              onError={(e) => {
                e.target.src = '/assets/blog/placeholder.jpg'
                e.target.alt = 'Blog post image'
              }}
            />
          </div>
          
          <div 
            className="blog-post-content"
            dangerouslySetInnerHTML={{ __html: post.content }}
          />
          
          <div className="blog-post-footer">
            <Link to={blogPath} className="btn primary">
              {t.blog.backToBlog}
            </Link>
          </div>
        </div>
      </article>
    </>
  )
}

export default BlogPost
